<p>{{ 'app.addons.manage_repositories_works' | translate }}!</p>
